
// #11 – BREADCRUMB
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var debounce = require('../utilities/debounce');

module.exports = function (options) {
    var context = options.context;
    var openClass = 'is-open';
    var isMobile = false;
    var closedHeight;
    var expandedHeight = 0;
    var changeSize;
    var compactor = $('<li class="breadcrumb__item"><span class="separator"><!--[if gte IE 9]><!--><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="8px" height="13px" viewBox="23.167 -25.833 45.667 96.333" enable-background="new 23.167 -25.833 45.667 96.333" xml:space="preserve"><polyline fill="none" stroke="#4f4c54" stroke-width="3" stroke-miterlimit="10" points="25.05,69.15 66.95,22.55 25.05,-24.05 "></polyline></svg><!--<![endif]--><!--[if lte IE 8]><img src="/Static/images/icons/arrow-right-grey.png" alt="Right arrow" /><![endif]--></span><a href="#breadcrumb" class="link" data-binding="breadcrumb-compact">...</a></li>');

    function setMobile() {
        //Check if mobile
        if (context.css('overflow') === 'hidden') {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    function init() {

        /**
        * Open breadcrumb to correct height
        */
        function openBreadcrumb(expandedHeight) {
            context.animate({
                height: expandedHeight
            });
            context.addClass(openClass);
        }

        /**
        * Close breadcrumb to initial height
        */
        function closeBreadcrumb(hiddenHeight) {
            context.animate({
                height: hiddenHeight
            });
            context.removeClass(openClass);
        }

        /**
         * Set open and closed heights for breadcrumb
         */
        function initBreadcrumb() {
            setMobile();
            context.find('[data-binding="breadcrumb-compact"]').parent().remove();

            if (isMobile === true) {
                context.find('.breadcrumb__item').show();

                // Calculate heights after resize
                expandedHeight = 0;
                closedHeight = context.find('.current-page').outerHeight();
                var i;
                var breadcrumbItems = context.children();
                for (i = 0; i < breadcrumbItems.length; i++) {
                    expandedHeight += parseInt($(breadcrumbItems[i]).outerHeight());
                }

                // if changed between desktop and mobile - close the breadcrumb
                if (changeSize !== false) {
                    changeSize = false;
                    context.addClass(openClass);
                    closeBreadcrumb(closedHeight);
                }
            } else {
                changeSize = true;
                // retain a background-image with the logo
                var backgroundImage = context.css('background-image');
                // remove all styles
                context.removeAttr('style');
                // bring back the background-image with the logo
                context.css('background-image', backgroundImage);

                if (context.find('.breadcrumb__item').length > 4) {
                    var breadcrumbLength = context.find('.breadcrumb__item').length;
                    // compact the breadcrumnb by replacing items in between first 2 and last 2 items
                    context.find('.breadcrumb__item').each(function (index, value) {
                        if (index > 1 && index < breadcrumbLength - 2) {
                            $(this).hide();
                        }
                    });
                    // insert placeholder > ... after 2nd breadcrumb element
                    compactor.insertAfter('.breadcrumb__item:nth-child(2)');
                }
            }
        }

        initBreadcrumb();

        /**
         * Add click event to mobile breadcrumb button
         */
        context.find('.toggle').on('click', function () {
            if (context.hasClass(openClass)) {
                closeBreadcrumb(closedHeight);
            } else {
                openBreadcrumb(expandedHeight);
            }
        });

        $(document).on('click', '[data-binding="breadcrumb-compact"]', function (e) {
            e.preventDefault();
            $(this).parent().remove();
            context.find('.breadcrumb__item').each(function (index, value) {
                if ($(this).css('display') === 'none') {
                    $(this).show();
                }
            });
        });

        // debouncing the modal window
        $(window).on('resize', debounce(function () {
            initBreadcrumb();
        }, 500));
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/breadcrumb-toggle.js
// module id = 192
// module chunks = 0